export default __webpack_public_path__ + "static/media/11.20.24 - Minutes of the Regular Meeting of the BOD.26879c4d.pdf";